module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("92doG"))).then(() => parcelRequire('c5nu5'));